'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

const __endpoints = require('endpoints.service');

export default class ContinentsList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'abbriviations',
				type: 'string',
				canAdd: true,
				canEdit: true,
			},
			{
				name: 'sort_order',
				type: 'number',
				canAdd: true,
				canEdit: true,
			},
		];

		this.settings = {
			name: 'ContinentsList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			pageTitle: true,
			searchList: {
				canAdd: true,
				canDelete: true,
			},
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),
			translationPath: 'ADMINISTRATION.CONTINENTS',
			endpoint: __endpoints.collection.administration.continents,
		};
		this.init();
		return this;
	}
}
